import { makeStyles } from "@material-ui/core";

export const useEditDemoVideoModalStyles = makeStyles((theme) => ({
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.4)",
    zIndex: 1300,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  modal: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    width: "100%",
    maxWidth: "584px",
    padding: "24px 28px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "90%",
      padding: "20px 16px",
    },
  },

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  title: {
    fontFamily: "'Inter', sans-serif",
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: 1.4,
    color: "#3D3D3D",
  },

  closeBtn: {
    cursor: "pointer",
    width: "28px",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    backgroundColor: "#F5F5F5",
    border: "none",
    padding: 0,
    color: "#666",
    "&:hover": {
      backgroundColor: "#E0E0E0",
    },
  },

  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },

  label: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: 1.4,
    color: "#3D3D3D",
  },

  input: {
    width: "100%",
    border: "1px solid #E0E0E0",
    borderRadius: "4px",
    padding: "10px 14px",
    fontSize: "16px",
    fontFamily: "'Inter', sans-serif",
    fontWeight: 500,
    lineHeight: 1.4,
    color: "#3D3D3D",
    outline: "none",
    backgroundColor: "transparent",
    boxSizing: "border-box",
    "&::placeholder": {
      color: "#999999",
    },
  },

  inputError: {
    border: "1px solid #E53935 !important",
  },

  errorText: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: 1.4,
    color: "#E53935",
  },

  saveBtn: {
    margin:"auto",
    width: "272px",
    padding: "14px",
    backgroundColor: "#FF712D",
    boxShadow: "0px 2px 4px 0px #00000014",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    lineHeight: 1.4,
    fontWeight: 600,
    fontFamily: "'Inter', sans-serif",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },

  spinner: {
    width: "18px",
    height: "18px",
    border: "2px solid rgba(255,255,255,0.4)",
    borderTop: "2px solid #fff",
    borderRadius: "50%",
    animation: "$spin 0.8s linear infinite",
  },

  "@keyframes spin": {
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(360deg)" },
  },
}));
